/******************************************************************************
 *** MbrasAtrzPrgrsinq ** 조합원 결재진행 조회
*******************************************************************************/
import AppContext from "@/js/common/AppContext";
import Axios from "@/js/common/Axios";
import Button from "@/js/common/ui/Button";
import GridTable, { fldInfsProps } from "@/js/common/ui/GridTable";
import AdminGridStyle from "@/js/common/ui/style/AdminGridStyle";
import Util from "@/js/common/Util";
import React from "react";
import DatePickerBox from "@/js/common/ui/input/DatePickerBox";
import SelectBox from "@/js/common/ui/input/SelectBox";
import TextBox from "@/js/common/ui/input/TextBox";
import * as Atom from "@/js/common/Atom";
import { useRecoilValue } from "recoil";
import Modal from "@/js/common/ui/modal/Modal";
import DialogTitleBar from "../../common/DialogTitleBar";
import MbrasNewHistory from "../atrz/history/MbrasNewHistory";
import MbrasWhdwlHistory from "../atrz/history/MbrasWhdwlHistory";
import MbrasRegulHistory from "../atrz/history/MbrasRegulHistory";
import MbrasDepartHistory from "../atrz/history/MbrasDepartHistory";
import MbrasLeaveHistory from "../atrz/history/MbrasLeaveHistory";
import MbrasLeaveExtendHistory from "../atrz/history/MbrasLeaveExtendHistory";
import MbrasReturnHistory from "../atrz/history/MbrasReturnHistory";
import MbrasResignHistory from "../atrz/history/MbrasResignHistory";
import MbrasRetireHistory from "../atrz/history/MbrasRetireHistory";
import MbrasRejoinHistory from "../atrz/history/MbrasRejoinHistory";
import { exportToXlsx } from "@/js/common/ExcelExport";

const MbrasAtrzPrgrsinq = () => {
    const userInfo = useRecoilValue(Atom.userInfo);

    // 검색 조건
    const [keyword       , setKeyword       ] = React.useState(""); // 성명
    const [mbrasAtrzSeCd , setMbrasAtrzSeCd ] = React.useState(""); // 결재구분
    const [ocptTypeCd    , setOcptTypeCd    ] = React.useState(""); // 직종
    const [sttDt         , setSttDt         ] = React.useState(""); // 결재상신일자 시작
    const [endDt         , setEndDt         ] = React.useState(""); // 결재상신일자 종료
    const [prcsAtrzSttsCd, setPrcsAtrzSttsCd] = React.useState("03"); // 결재진생상태(ATRZ_STTS_CD)

    const [dataArr, setDataArr] = React.useState<[]>([]);

    // 모달
    const [modalOpen     , setModalOpen     ] = React.useState(false);
    const [mbrasAtrzDocId, setMbrasAtrzDocId] = React.useState<string>(""); // 조합원 결재 문서ID
    const [mbrasId       , setMbrasId       ] = React.useState<string>(""); // 조합원 ID
    const [detailAtrzSeCd, setDetailAtrzSeCd] = React.useState<string>(""); // 결재문서 구분코드

    // =========================================================
    // GridTable 컬럼 정의
    // - 결재상신일자: ATRZ_REQ_DT_STR (백엔드에서 내려준 값 표시)
    // =========================================================
    const fldInfs: fldInfsProps[] = [
        { type: "seq" ,                          width:  50, headAlign: "center", dataAlign: "center", label: "No."          },
        { type: "text", fldNm: "mbrasId"       , width: 130, headAlign: "center", dataAlign: "center", label: "조합원번호"   },
        { type: "text", fldNm: "mbrasNm"       , width:  80, headAlign: "center", dataAlign: "center", label: "성명"         },
        { type: "el"  , fldNm: "mbrasAtrzSeCd" , width:  50, headAlign: "center", dataAlign: "center", label: "구분", el: (item: any) => <span className={"ls06 " + (item.mbrasAtrzSeCd === "03" ? "fcE53935" : "")}>{Util.getValToCode("MBRAS_ATRZ_SE_CD", item.mbrasAtrzSeCd)}</span> },
        { type: "text", fldNm: "upOgnzNm"      , width: 100, headAlign: "center", dataAlign: "center", label: "본부"         },
        { type: "text", fldNm: "ognzNm"        , width: 100, headAlign: "center", dataAlign: "center", label: "지부"         },
        { type: "text", fldNm: "wtjrNm"        , width: 140, headAlign: "center", dataAlign: "center", label: "관내"         },
        { type: "code", fldNm: "ocptTypeCd"    , width: 110, headAlign: "center", dataAlign: "center", label: "직종", catCode: "OCPT_TYPE_CD" },
        { type: "code", fldNm: "atrzSttsCd"    , width:  70, headAlign: "center", dataAlign: "center", label: "결재진행", catCode: "ATRZ_STTS_CD" },
        { type: "text", fldNm: "atrzSeqNm"     , width:  90, headAlign: "center", dataAlign: "center", label: "결재단계"     },
        { type: "text", fldNm: "aprvrNm"       , width:  90, headAlign: "center", dataAlign: "center", label: "결재자"       },
        { type: "text", fldNm: "atrzAplcntNm"  , width:  90, headAlign: "center", dataAlign: "center", label: "상신자"       },
        { type: "date", fldNm: "atrzReqDt"     , width: 100, headAlign: "center", dataAlign: "center", label: "상신일자"     },
    ];

     // 엑셀 다운로드용
    const fldInfsExcel: fldInfsProps[] = [
        { type: "seq" ,                         width:  50, headAlign: "center", dataAlign: "center", label: "No."          },
        { type: "text", fldNm: "mbrasId"      , width: 130, headAlign: "center", dataAlign: "center", label: "조합원번호"   },
        { type: "text", fldNm: "mbrasNm"      , width:  80, headAlign: "center", dataAlign: "center", label: "성명"         },
        { type: "code", fldNm: "mbrasAtrzSeCd", width:  50, headAlign: "center", dataAlign: "center", label: "구분",     catCode: "MBRAS_ATRZ_SE_CD" },
        { type: "text", fldNm: "upOgnzNm"     , width: 100, headAlign: "center", dataAlign: "center", label: "본부"         },
        { type: "text", fldNm: "ognzNm"       , width: 100, headAlign: "center", dataAlign: "center", label: "지부"         },
        { type: "text", fldNm: "wtjrNm"       , width: 140, headAlign: "center", dataAlign: "center", label: "관내"         },
        { type: "code", fldNm: "ocptTypeCd"   , width: 110, headAlign: "center", dataAlign: "center", label: "직종",     catCode: "OCPT_TYPE_CD" },
        { type: "code", fldNm: "atrzSttsCd"   , width:  70, headAlign: "center", dataAlign: "center", label: "결재진행", catCode: "ATRZ_STTS_CD" },
        { type: "text", fldNm: "atrzSeqNm"    , width:  90, headAlign: "center", dataAlign: "center", label: "결재단계"     },
        { type: "text", fldNm: "aprvrNm"      , width:  90, headAlign: "center", dataAlign: "center", label: "결재자"       },
        { type: "text", fldNm: "atrzAplcntNm" , width:  90, headAlign: "center", dataAlign: "center", label: "상신자"       },
        { type: "date", fldNm: "atrzReqDt"    , width: 100, headAlign: "center", dataAlign: "center", label: "상신일자"     },
    ];

    // 목록 조회
    React.useEffect(() => {
        // 작성일자 검색 조건 확인
        if (Util.isNotEmpty(sttDt) && Util.isNotEmpty(endDt)) {
            if (sttDt > endDt) {
                AppContext.openAlert({ 
                    title: "결재상신일자 검색 조건 확인", 
                    msg: "결재상신일자의 검색 시작일자가 종료일자보다 느립니다.", 
                    icon: "warning" 
                }); 
                setEndDt("")
                return;
            } 
        }
        AppContext.showSpinner();
        Axios.dataAccess({
            url: "system/mbra/atrzprgrs/select-mbras-atrz-prgrs.do",
            methodType: "post",
            paramType : "json",
            paramData : {
                mbrasAtrzSeCd : mbrasAtrzSeCd,
                upOgnzCd      : userInfo.ognzCd === "00_000" ? "" : userInfo.upOgnzCd, // 조합본부(00_000): 모든 조합원 조회
                ognzCd        : userInfo.ognzCd.includes("000") ? "" : userInfo.ognzCd, // 지방본부(000): 해당 지방본부만                
                ocptTypeCd    : ocptTypeCd,
                prcsAtrzSttsCd: prcsAtrzSttsCd, // 결재진행상태
                sttDt         : sttDt,
                endDt         : endDt,
            },
            onSuccessFn: (res: any) => {
                setDataArr(res.result.list);
                AppContext.hideSpinner();
            },
        });
    }, [mbrasAtrzSeCd, userInfo, ocptTypeCd, prcsAtrzSttsCd, sttDt, endDt]);

    // 엑셀 다운로드
    const downloadExcel = () => {
        if (Util.filterFieldData(dataArr as any, fldInfsExcel, "mbrasNm", keyword).length === 0) {
        AppContext.openAlert({
            title: "데이터 확인",
            msg: "엑셀로 다운로드할 데이터가 없습니다.",
            icon: "warning",
        });
        return;
        }

        exportToXlsx({
        fileName: `조합원 결재진행 목록`,
        title: "조합원 결재진행 목록",
        columns: fldInfsExcel,
        rows: Util.filterFieldData(dataArr as any, fldInfsExcel, "mbrasNm", keyword),
        });
    };

    // render
    return (
        <div className="w1200 bgcWhite p20 bdrd8 mt10 boxShadowSoft">
            {/* 타이틀 */}
            <div className="mt5">
                <span className="posR dpBlock w100p fm-c fs25 fc2c3e50 ls1 pb10">조합원 결재 조회</span>
                <div className="bdt3 bdc007bff pb10"></div>
            </div>

        {/* 검색 조건   */}
        <div className="bd1 bdcDDDDDD p20 bdrd6 bgcFAFAFA mb10">
            <div className="dpFlx aiC flxWrap gap14">
                {/* 성명/조합원 번호 */}
                <div className="dpFlx aiC">
                    <span className="w40 fm-c fs15 fc333333 ls1 taL">성명</span>
                    <TextBox value={keyword}
                        width={120} height={36}
                        fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                        borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                        style={{ backgroundColor: "#fff", padding: "0 10px" }}
                        placeholder="성명 입력"
                        onChangeFunc={(text: string) => setKeyword(text)}
                    />
                </div>

                {/* 결재 구분 */}
                <div className="dpFlx aiC">
                    <span className="w80 fm-c fs15 fc333333 ls1 taL ">결재 구분</span>
                    <SelectBox value={mbrasAtrzSeCd}
                        width={100} height={36}
                        fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                        borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                        background="#fff" paddingRight={8}
                        codeArray={[{ code: "", name: "전체" }].concat(Util.getCodeArray("UI_MBRAS_ATRZ_SE_CD_01"))}
                        placeholder="전체"
                        onChangeFunc={(data: string) => setMbrasAtrzSeCd(data)}
                    />
                </div>

                {/* 직종 */}
                <div className="dpFlx aiC">
                    <span className="w40 fm-c fs15 fc333333 ls1 taL">직종</span>
                    <SelectBox value={ocptTypeCd}
                        width={150} height={36}
                        fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                        borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                        background="#fff" paddingRight={8}
                        codeArray={[{ code: "", name: "전체" }].concat(Util.getCodeArray("OCPT_TYPE_CD"))}
                        placeholder="전체"
                        onChangeFunc={(data: string) => setOcptTypeCd(data)}
                    />
                </div>

                {/* 결재 진행상태 */}
                <div className="dpFlx aiC">
                    <span className="w100 fm-c fs15 fc333333 ls1 taL ">결재 진행상태</span>
                    <SelectBox value={prcsAtrzSttsCd}
                        width={130} height={36}
                        fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                        borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                        background="#fff" paddingRight={8}
                        codeArray={[{ code: "", name: "전체" }].concat(Util.getCodeArray("ATRZ_STTS_CD").filter(item => item.code === '03' || item.code === '05'))}
                        placeholder="전체"
                        onChangeFunc={(data: string) => setPrcsAtrzSttsCd(data)}
                    />
                </div>

                {/* 결재상신일자 기간 */}
                <div className="dpFlx aiC">
                    <span className="w100 fm-c fs15 fc333333 ls1 taL">결재상신일자</span>
                    <DatePickerBox value={sttDt}
                        width={150} height={36}
                        fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                        borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                        bgColor="white" textAlign="left"
                        calendarThemeColor={AppContext.themeColor}
                        className="mr5"
                        onChange={(data: string) => setSttDt(data)}
                    />
                    <span className="fm-c fc666666 mr5">~</span>
                        <DatePickerBox value={endDt}
                            width={150} height={36}
                            fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                            bgColor="white" textAlign="left"
                            calendarThemeColor={AppContext.themeColor}
                            className="mr5"
                            onChange={(data: string) => setEndDt(data)}
                        />
                </div>

                {/* 검색 버튼 */}
                <div className="dpFlx aiC mlA gap10">
                    <Button buttonName="초기화"
                        width={75} height={40}
                        fontFamily="fm-b" fontSize={16} letterSpacing={-1}
                        variant="styInitBtn"
                        borderRadius={6} buttonClass="dpFlx aiC jcC"
                        onClickFunc={() => {
                            setKeyword("");
                            setMbrasAtrzSeCd("");
                            setOcptTypeCd("");
                            setPrcsAtrzSttsCd("03"); // 결재 중(03)
                            setSttDt("");
                            setEndDt("");
                        }}
                    />
                </div>
            </div>
        </div>

        {/* 목록 헤더 */}
        <div className="dpFlx aiC jcSb mb10 h44">
            <div className="fm-b fs16 fc007bff ls1 fw700">
                <span>결재 목록</span>
            </div>
            <Button
                width={150}
                height={40}
                fontFamily="fm-b"
                fontSize={16}
                letterSpacing={-1}
                variant="styExcelBtn"
                borderRadius={6}
                buttonClass="dpFlx aiC jcC"
                buttonName="Excel 다운로드"
                onClickFunc={downloadExcel}
            />
        </div>

        {/* GridTable: 목록 */}
        <GridTable
            tableInfo={{
                tableHeadVsb: true,
                styleType: AdminGridStyle,
                fldInfs,
                ordFld: { name: "mbrasId", direction: "desc" },
                dataArr: Util.filterFieldData(dataArr as any, fldInfs, "mbrasNm", keyword),
                maxRowNums: [30, 50, 100],
                theadTrHeight: 40,
                tbodyTrHeight: 35,
                paginateClass: "pt10",
                paginateStyle: {
                    buttonOnColor: AppContext.boardThemeColor,
                    buttonWidth: 22,
                    buttonHeight: 24,
                    buttonMarginLeft: 1,
                    buttonMarginRight: 1,
                    fontSize: 13,
                    color: "#666666",
                    letterSpacing: -0.8,
                    fontFamily: "Pretendard-Regular",
                    borderRadius: 3,
                },
                footerVsb: true,
                rowClickFunc: (row: any) => {
                    setMbrasId(row.mbrasId);
                    setMbrasAtrzDocId(row.mbrasAtrzDocId);
                    setDetailAtrzSeCd(row.mbrasAtrzSeCd);
                    setModalOpen(true);
                },
            }}
        />

        <Modal modalOpen={modalOpen} dim={true} visible={true} width={760} titleEl={<DialogTitleBar title={"조합원 결재 상세"} />}
            onCloseFunc={() => {
                setMbrasId("");
                setMbrasAtrzDocId("");
                setDetailAtrzSeCd("");
                setModalOpen(false);
            }}
        >
            <div className="h900">
                {detailAtrzSeCd === "01" && (
                    <MbrasNewHistory
                        mbrasId={mbrasId}
                        mbrasAtrzDocId={mbrasAtrzDocId}
                    />
                )}

                {detailAtrzSeCd === "03" && (
                    <MbrasWhdwlHistory
                        mbrasId={mbrasId}
                        mbrasAtrzDocId={mbrasAtrzDocId}
                    />
                )}

                {detailAtrzSeCd === "04" && (
                    <MbrasRegulHistory
                        mbrasId={mbrasId}
                        mbrasAtrzDocId={mbrasAtrzDocId}
                    />
                )}

                {detailAtrzSeCd === "05" && (
                    <MbrasDepartHistory
                        mbrasId={mbrasId}
                        mbrasAtrzDocId={mbrasAtrzDocId}
                    />
                )}

                {detailAtrzSeCd === "06" && (
                    <MbrasLeaveHistory
                        mbrasId={mbrasId}
                        mbrasAtrzDocId={mbrasAtrzDocId}
                    />
                )}

                {detailAtrzSeCd === "07" && (
                    <MbrasLeaveExtendHistory
                        mbrasId={mbrasId}
                        mbrasAtrzDocId={mbrasAtrzDocId}
                    />
                )}

                {detailAtrzSeCd === "08" && (
                    <MbrasReturnHistory
                        mbrasId={mbrasId}
                        mbrasAtrzDocId={mbrasAtrzDocId}
                    />
                )}

                {detailAtrzSeCd === "09" && (
                    <MbrasResignHistory
                        mbrasId={mbrasId}
                        mbrasAtrzDocId={mbrasAtrzDocId}
                    />
                )}

                {detailAtrzSeCd === "10" && (
                    <MbrasRetireHistory
                        mbrasId={mbrasId}
                        mbrasAtrzDocId={mbrasAtrzDocId}
                    />
                )}

                {detailAtrzSeCd === "11" && (
                    <MbrasRejoinHistory
                        mbrasId={mbrasId}
                        mbrasAtrzDocId={mbrasAtrzDocId}
                    />
                )}

                <div className="dpFlx jcC mt25 mb10 gap10">
                    <Button
                        width={100}
                        height={40}
                        fontFamily="fm-b"
                        fontSize={16}
                        letterSpacing={-1}
                        variant="styCloseBtn"
                        borderRadius={6}
                        buttonClass="dpFlx aiC jcC"
                        buttonName="닫기"
                        onClickFunc={() => {
                            setMbrasId("");
                            setMbrasAtrzDocId("");
                            setDetailAtrzSeCd("");
                            setModalOpen(false);
                        }}
                    />
                </div>
            </div>
        </Modal>
        </div>
    );
};

export default MbrasAtrzPrgrsinq;